import React from 'react'

export default function FaceFeature({ scale, verticalOffset = 0 }) {
  // Calculate center point for the SVG
  // x-coordinates range from about 0.57 to 50.29, y-coordinates from -0.65 to 18.28
  const transformOrigin = '25.4 9.1'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M3.58969 4.11987C3.58969 4.11987 3.08969 11.9899 8.5297 15.0799C14.1597 18.2799 22.6697 15.0398 22.4797 6.83984"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M22.77 6.30993C22.77 6.30993 25.11 5.20993 28.11 6.30993"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M4.08981 6.92993C4.08981 6.92993 2.9698 2.41993 8.3598 1.86993C13.6798 1.32993 21.2398 2.60992 22.1498 7.41992C22.1498 7.41992 22.9098 7.5399 23.1498 6.9699C23.3898 6.3999 22.9898 1.82994 14.4698 0.509943C7.00982 -0.650057 0.569824 0.529902 0.569824 0.529902L0.709808 2.90991C0.709808 2.90991 1.34982 3.28995 1.84982 4.38995C2.12982 5.00995 2.22981 7.11993 4.08981 6.92993Z"
        fill="#231F20"
      />
      <path
        d="M2.24988 2.58984C2.59229 2.58984 2.86987 2.31227 2.86987 1.96985C2.86987 1.62743 2.59229 1.34985 2.24988 1.34985C1.90746 1.34985 1.62988 1.62743 1.62988 1.96985C1.62988 2.31227 1.90746 2.58984 2.24988 2.58984Z"
        fill="white"
      />
      <path
        d="M47.2701 4.11987C47.2701 4.11987 47.7701 11.9899 42.3301 15.0799C36.7001 18.2799 28.1901 15.0398 28.3801 6.83984"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M46.7696 6.92993C46.7696 6.92993 47.8896 2.41993 42.4996 1.86993C37.1796 1.32993 29.6196 2.60992 28.7096 7.41992C28.7096 7.41992 27.9496 7.5399 27.7096 6.9699C27.4696 6.3999 27.8696 1.82994 36.3896 0.509943C43.8496 -0.650057 50.2896 0.529902 50.2896 0.529902L50.1496 2.90991C50.1496 2.90991 49.5096 3.28995 49.0096 4.38995C48.7296 5.00995 48.6296 7.11993 46.7696 6.92993Z"
        fill="#231F20"
      />
      <path
        d="M48.6 2.58984C48.9424 2.58984 49.22 2.31227 49.22 1.96985C49.22 1.62743 48.9424 1.34985 48.6 1.34985C48.2576 1.34985 47.98 1.62743 47.98 1.96985C47.98 2.31227 48.2576 2.58984 48.6 2.58984Z"
        fill="white"
      />
    </g>
  )
}
